// extracted by mini-css-extract-plugin
export default {"EventBadges":"Styles_EventBadges__VGrvF","NationwideBadge":"Styles_NationwideBadge__RltgV","VenueTypeLabel":"Styles_VenueTypeLabel__knfPm","SeriesBadge":"Styles_SeriesBadge__UAVNE"};